import React from 'react';
import Spinner from '@ux/spinner';
import { Button } from '@sso/components';
import PropTypes from 'prop-types';

import InstrumentedButton from '../traffic/InstrumentedButton';

const withSpinner = Component => {
  const ButtonWithSpinner = ({ showSpinner, ...passThroughProps }) => (
    <Component
      icon={showSpinner && <Spinner size='sm' design='inline' shade='dark' data-testid='spinner' />}
      {...passThroughProps}
    />
  );

  ButtonWithSpinner.propTypes = {
    showSpinner: PropTypes.bool.isRequired,
  };

  return ButtonWithSpinner;
};

withSpinner.propTypes = {
  Component: PropTypes.element.isRequired,
};

export const InstrumentedButtonWithSpinner = withSpinner(InstrumentedButton);
export const ButtonWithSpinner = withSpinner(Button);
